import React, { useMemo } from 'react';
import { useTable, Column } from 'react-table';
import './././../../components/data-tables/DataTable.scss';
import './widget-tables.scss';

interface WellStatusOverview {
  label: string;
  value: string;
  isVisible: boolean;
  displayState: number;
}

interface TaskDataTableProps {
  data: WellStatusOverview[];
}

const RodLiftStatusRegisterTable: React.FC<TaskDataTableProps> = ({ data }) => {
  const visibleData = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }
    return data.filter((item) => item.isVisible && item.label.trim() !== '');
  }, [data]);

  const columns: Column<WellStatusOverview>[] = useMemo(
    () => [
      {
        accessor: 'label',
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        accessor: 'value',
        Cell: ({ value }) => <span>{value} %</span>,
      },
    ],
    [],
  );

  const { getTableProps, getTableBodyProps, rows, prepareRow } = useTable({
    columns,
    data: visibleData,
  });

  return (
    <section className='table-container-wrapper mt-4 widget-table-wrapper'>
      <div className='table-container p-0'>
        <div className='table-wrapper'>
          <table {...getTableProps()} className='data-table widget-table center-text table'>
            <thead>{/* Optionally leave header empty if needed */}</thead>

            <tbody {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} className='table-row'>
                      {row.cells.map((cell, index) => (
                        <td key={index} className='table-cell'>
                          <div className={cell.column.id === 'label' ? 'text-left' : 'text-right'}>
                            {cell.render('Cell')}
                          </div>
                        </td>
                      ))}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={2} className='text-center'>
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default RodLiftStatusRegisterTable;
